export default __webpack_public_path__ + "static/media/seisodinIconBlack.8a4883d7.png";